/**
 * Post-login landing logic, single source of truth.
 *
 * Both the email/password quick-login (Header.js) and the Google OAuth
 * callback (AuthCallback.js) consult this helper to decide where to send
 * a freshly authenticated user. Centralising the rule means new roles or
 * landing splits only need one edit.
 *
 * Current rule (per product, May 2026): every authed user lands on the
 * marketing homepage `/` and chooses where to go from there. Forcing
 * admins straight to /admin-dashboard or kids to /my-world skipped the
 * "you're now part of Isaiah's World" homepage moment that the user
 * explicitly wants every founder to see post-login.
 */
export function getPostLoginLanding(user, opts = {}) {
  if (opts.needsCompletion) return "/complete-profile";
  return "/";
}
